import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../baseClasses/BaseComponent';
import ChronologicalItemList from '../../../components/ChronologicalItemList';
import fileUtil from '../../../helpers/FileUtil/FileUtil';

import './ReferenceDocumentHistory.scss';

export class ReferenceDocumentHistory extends BaseComponent {
  constructor(props) {
    super(props);

    ReferenceDocumentHistory.propTypes = {
      // historyItems - object[] - the list of documents to populate the history view
      historyItems: PropTypes.array,
    };

    this.getHistoryCard = this.getHistoryCard.bind(this);
    this.setLatestVersionId = this.setLatestVersionId.bind(this);
  }

  componentDidMount() { }

  setLatestVersionId() {
    //API sorts docs in descending order, so the first result is the latest version
    if(this.props.historyItems) {
      this.latestVersionID = this.props.historyItems[0].id;
    }
  }

  /**
   * RENDER FUCNTIONS
   */
  getHistoryCard(historyItem, date) {
    let currentVersionIndicator;
    if (historyItem.id == this.latestVersionID) {
      //add current version indicator to history item
      currentVersionIndicator = <p className="doc-history-card__current-version">Current Version</p>;
    }
    return (
      <div className="doc-history-card" key={historyItem.id}>
        <p className="doc-history-card__title">{fileUtil.trimExtension(historyItem.name)}</p>
        {currentVersionIndicator}
        <p className="doc-history-card__uploaded-by">
          <span>Uploaded By </span>
          |<span className="doc-history-card__uploaded-name"> {historyItem.user ? historyItem.user.name : 'Unknown'}</span>
        </p>
      </div>
    );
  }

  render() {
    this.setLatestVersionId();
    return (
      <section className="document-history-container">
        <h2>HISTORY</h2>
        <div className="history-scroll-container">
          <ChronologicalItemList
            items={this.props.historyItems}
            getItemCard={this.getHistoryCard}
            itemsName="history entires"
          ></ChronologicalItemList>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentHistory/index.js